import {
    PatientCareProviderModel,
} from 'one-card-pcp';


import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

/**
 *
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const pcpstate = (
    context: any,
    initial?: PatientCareProviderModel[],
) => {
    let initialstate = initial || [];
    return (
        state: PatientCareProviderModel,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let updated = state || initialstate;

        switch (type) {
            case SET:
                updated = payload
                break;
            case REINIT:
                updated = initialstate
                break;
        }
        return updated;
    }
};
